import axios from "axios";

const apicontact = axios.create({
    baseURL: "https://api.zplayer.app/api",
    headers: {
        "Content-Type": "application/json",
    },
});

// Function to get token from localStorage
const getAuthToken = () => {
    const token = localStorage.getItem("authTokenZplayer");
    return token ? JSON.parse(token) : null;
};

// Request Interceptor: Automatically attach token to every request
apicontact.interceptors.request.use(
    (config) => {
        const token = getAuthToken();
        if (token) {
            config.headers["X-CSRF-Token"] = token;
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);



export default apicontact;
